<template lang="">
    <div class="footer_navi clearfix">
        <ul class="clearfix">
            <li>
                <a
                    target="_blank"
                    href="https://www.agropedia.affrc.go.jp/copyright"
                    >著作権・免責事項等</a
                >
            </li>
            <li>
                <a
                    target="_blank"
                    href="https://www.agropedia.affrc.go.jp/privacy"
                    >プライバシーポリシー</a
                >
            </li>
            <li>
                <a
                    target="_blank"
                    href="https://www.agropedia.affrc.go.jp/inquiry"
                    >お問い合わせ</a
                >
            </li>
        </ul>
        <div class="pagetop">
            <a href="#header">このページの先頭へ</a>
        </div>
    </div>
    <footer id="footer">
        <div class="inner">
            <div class="footer_logo">
                <!-- src="/themes/custom/agrknldgtheme/common/images/site_lgo.png" -->
                <img src="/images/site_lgo.png" alt="AgriKnowledge" />
            </div>
            <div class="copyright">
                <p>
                    Copyright 2022 農林水産省
                    農林水産技術会議事務局筑波産学連携支援センター
                </p>
                <p>
                    Tsukuba Business-Academia Cooperation Support Center,
                    Agriculture, Forestry and Fisheries Research Council
                    Secretariat
                </p>
            </div>
        </div>
    </footer>
    <!-- /.inner, /#footer -->
</template>

<script>
export default {
    name: "AppFooter",
};
</script>

<style>
/*----------------------------------------
	footer_navi
----------------------------------------*/
.footer_navi {
    width: 980px;
    margin: 70px auto 10px;
    font-size: 92.85%;
}
.footer_navi ul {
    float: left;
    margin-top: 8px;
}
.footer_navi li {
    float: left;
}
.footer_navi li a {
    /* background: url(../images/icon_leaf.jpg) no-repeat scroll 0 6px; */
    background: url("../../public/images/icon_leaf.jpg") no-repeat scroll 0 6px;
    display: block;
    padding-left: 19px;
    text-decoration: underline;
}
.footer_navi li + li {
    margin-left: 20px;
}

/* pagetop */
.footer_navi .pagetop {
    float: right;
    width: 150px;
}
.footer_navi .pagetop a {
    color: #fff;
    text-align: center;
    text-decoration: none;
    background-color: #188031;
    border-radius: 6px;
    display: block;
    padding: 4px 0;
}

/*----------------------------------------
	footer
----------------------------------------*/
#footer {
    background-color: #edf1f1;
    border-bottom: 8px solid #188031;
    position: relative;
}
#footer::before {
    content: "";
    width: 100%;
    height: 1px;
    position: absolute;
    left: 0;
    bottom: 1px;
    background-color: #188031;
}
#footer > .inner {
    width: 980px;
    padding: 25px 0 35px;
    margin: 0 auto;
}

#footer .footer_logo {
    width: 200px;
}
#footer .copyright {
    color: #525252;
    font-size: 92.85%;
    margin-top: 5px;
}
</style>
